import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadablePartnerTermsAndConditions = Loadable({
  loader: function loader() {
    return import('../PartnerTermsAndConditions.jsx');
  },
  loading: ComponentLoading
});
export default LoadablePartnerTermsAndConditions;